<div id="transferSetupDialog">
    <mat-dialog-content>
        Warehouse: <mayer-warehouse-selector name="warehouseID" [formControl]="warehouseID">
        </mayer-warehouse-selector>
    </mat-dialog-content>

    <mat-dialog-actions style="justify-content: space-between;">
        <button matSuffix mat-raised-button mat-dialog-close style="justify-content: flex-end;">Cancel</button>
        <button matSuffix mat-raised-button color="primary" (click)="closeWithWarehouseID()"
            style="justify-content: flex-end;">OK</button>
    </mat-dialog-actions>
</div>